import { FC, PropsWithChildren } from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

const ConditionalTooltip: FC<PropsWithChildren<TooltipProps & { condition?: boolean }>> = ({ condition, children, ...rest }) =>
    condition ? <Tooltip {...rest}>{children}</Tooltip> : children;

export default ConditionalTooltip;
